// extracted by mini-css-extract-plugin
export var form = "_ea-0";